"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { navItems, siteConfig } from "@/lib/site-data";

export default function Header() {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 980) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "header-scrolled" : ""}`}>
      <div className="container header-inner">
        <Link href="/" className="brand" aria-label="Jeevan Residency home page">
          <span className="brand-mark" aria-hidden="true">
            <Image src="/assets/jeevan-logo.png" alt="" width={48} height={48} priority />
          </span>
          <span>
            <strong>Jeevan Residency</strong>
            <small>Rameswaram</small>
          </span>
        </Link>

        <nav className="desktop-nav" aria-label="Main navigation">
          {navItems.map((item) => (
            item.externalHref ? (
              <a key={item.href} href={item.externalHref}>
                {item.label}
              </a>
            ) : (
              <Link
                key={item.href}
                href={item.href}
                className={
                  pathname === item.href ||
                  (item.href === "/blog" && pathname.startsWith("/blog/"))
                    ? "active"
                    : ""
                }
              >
                {item.label}
              </Link>
            )
          ))}
        </nav>

        <div className="header-actions">
          <a href={siteConfig.phoneHref} className="btn btn-secondary btn-small">
            Call
          </a>
          <a href={siteConfig.bookingUrl} className="btn btn-primary btn-small">
            Book Now
          </a>
        </div>

        <button
          type="button"
          className={`mobile-menu-toggle ${menuOpen ? "is-open" : ""}`}
          aria-label={menuOpen ? "Close menu" : "Toggle menu"}
          aria-expanded={menuOpen}
          aria-controls="mobile-navigation"
          onClick={() => setMenuOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <nav
        id="mobile-navigation"
        className={`mobile-nav ${menuOpen ? "open" : ""}`}
        aria-label="Mobile navigation"
        aria-hidden={!menuOpen}
      >
        {navItems.map((item) => (
          item.externalHref ? (
            <a key={item.href} href={item.externalHref} onClick={() => setMenuOpen(false)}>
              {item.label}
            </a>
          ) : (
            <Link key={item.href} href={item.href} onClick={() => setMenuOpen(false)}>
              {item.label}
            </Link>
          )
        ))}
        <div className="mobile-nav-actions">
          <a href={siteConfig.phoneHref} className="btn btn-secondary btn-small">
            Call
          </a>
          <a href={siteConfig.bookingUrl} className="btn btn-primary btn-small">
            Book Now
          </a>
        </div>
      </nav>
    </header>
  );
}
